export enum ApiQueryKey {
  Dictionary = 'api/dictionary',
  AzureResource = 'azure/resource',
}
